
export enum AvGatedSensorFieldIds {
    UltrasonicFlowType = 'av-gated-ultrasonicFlowType',
    PhysicalOffset = 'av-gated-physicalOffset',
    
    UltrasonicEnable = 'av-gated-ultrasonicEnable',
    UltrasonicElectronicOffset = 'av-gated-ultrasonicElectronicOffset',
    UltrasonicDeadband = 'av-gated-ultrasonicDeadband',
    UltrasonicStoreData = 'av-gated-ultrasonicStoreData',
    
    PressureEnable = 'av-gated-pressureEnable',
    PressureElectronicOffset = 'av-gated-pressureElectronicOffset',
    PressureStoreData = 'av-gated-pressureStoreData',
    PressureCalibration = 'av-gated-pressureCalibration',
    
    VelocityEnable = 'av-gated-velocityEnable',
    VelocityDirection = 'av-gated-velocityDirection',
    VelocityMinimum = 'av-gated-velocityMinimum',
    VelocityMaximum = 'av-gated-velocityMaximum',
    VelocityAcquisition = 'av-gated-velocityAcquisition',
    VelocityStoreData = 'av-gated-velocityStoreData',
    VelocityScrubbing = 'av-gated-velocityScrubbing',
    
    TemperatureStoreData = 'av-gated-temperatureStoreData',

    VelocityGain = 'av-gated-velocityGain',
    VelocitySensitivity = 'av-gated-velocitySensitivity',
    VelocityDacGain = 'av-gated-velocityDacGain',
    VelocityPingAmplitude = 'av-gated-velocityPingAmplitude',
    VelocityFrequency = 'av-gated-velocityFrequency',
    UltrasonicDacGain = 'av-gated-ultrasonicDacGain',
    UltrasonicPingAmplitude = 'av-gated-ultrasonicPingAmplitude',
}

export enum LongRangeSensorFieldIds {
    PhysicalOffset = 'long-range-physicalOffset',
    StoreData = 'long-range-storeData',
    Blanking = 'long-range-blanking',
    TemperatureSensor = 'long-range-temperatureSensor',
    Power = 'long-range-power',
    ElectronicOffset = 'long-range-electronicOffset',
    GainControlSelection = 'long-range-gainControlSelection',
    GainControl = 'long-range-gainControl',
    CompensatedTemperatureMarch = 'long-range-compensatedTemperatureMarch',
    CompensatedTemperatureSeptember = 'long-range-compensatedTemperatureSeptember',
    DisableCapacitance = 'long-range-disableCapacitance',
    LogCapacitance = 'long-range-logCapacitance',
    SurchargeThreshold = 'long-range-surchargeThreshold',
}

export enum PeakComboSensorFieldIds {
    UltrasonicFlowType = 'peak-combo-ultrasonicFlowType',
    PhysicalOffset = 'peak-combo-physicalOffset',
    
    UltrasonicEnable = 'peak-combo-ultrasonicEnable',
    UltrasonicElectronicOffset = 'peak-combo-ultrasonicElectronicOffset',
    UltrasonicDeadband = 'peak-combo-ultrasonicDeadband',
    UltrasonicStoreData = 'peak-combo-ultrasonicStoreData',
    
    PressureEnable = 'peak-combo-pressureEnable',
    PressureElectronicOffset = 'peak-combo-pressureElectronicOffset',
    PressureStoreData = 'peak-combo-pressureStoreData',
    PressureCalibration = 'peak-combo-pressureCalibration',
    
    VelocityEnable = 'peak-combo-velocityEnable',
    VelocitySensitivity = 'peak-combo-velocitySensitivity',
    VelocityDirection = 'peak-combo-velocityDirection',
    VelocityGain = 'peak-combo-velocityGain',
    VelocityMaximum = 'peak-combo-velocityMaximum',
    PeakComboMaxVelocityInput = 'peak-combo-peakComboMaxVelocityInput',
    VelocityStoreData = 'peak-combo-velocityStoreData',
    VelocityScrubbing = 'peak-combo-velocityScrubbing',
    
    VelocityFlowType = 'peak-combo-velocityFlowType',
    TransmitFrequency = 'peak-combo-transmitFrequency',
    
    TemperatureStoreData = 'peak-combo-temperatureStoreData',
    Sensor = 'peak-combo-sensor'
}

export enum SmartDepthSensorFieldIds {
    PhysicalOffset = 'smart-depth-physicalOffset',
    UltrasonicElectronicOffset = 'smart-depth-ultrasonicElectronicOffset',
    UltrasonicMode = 'smart-depth-ultrasonicMode',
    UltrasonicBlanking = 'smart-depth-ultrasonicBlanking',
    UltrasonicStoreData = 'smart-depth-ultrasonicStoreData',
    UltrasonicDisableSurchargeDetection = 'smart-depth-ultrasonicDisableSurchargeDetection',
    TemperatureStoreData = 'smart-depth-temperatureStoreData',
    TemperatureSensor = 'smart-depth-temperatureSensor',
    UltrasonicDacGain = 'smart-depth-ultrasonicDacGain',
}

export enum SurfaceComboSensorFieldIds {
    // Ultrasonic/Surface fields
    PhysicalOffset = 'surface-combo-physicalOffset',
    UltrasonicElectronicOffset = 'surface-combo-ultrasonicElectronicOffset',
    UltrasonicMode = 'surface-combo-ultrasonicMode',
    UltrasonicBlanking = 'surface-combo-ultrasonicBlanking',
    UltrasonicDisableSurchargeDetection = 'surface-combo-ultrasonicDisableSurchargeDetection',
    UltrasonicStoreData = 'surface-combo-ultrasonicStoreData',

    // Surface Velocity fields
    SurfaceVelocityEnable = 'surface-combo-surfaceVelocityEnable',
    SurfaceVelocityFrequency = 'surface-combo-surfaceVelocityFrequency',
    SurfaceVelocitySensitivity = 'surface-combo-surfaceVelocitySensitivity',
    SurfaceVelocityDirection = 'surface-combo-surfaceVelocityDirection',
    SurfaceVelocityMaximum = 'surface-combo-surfaceVelocityMaximum',
    SurfaceVelocityGain = 'surface-combo-surfaceVelocityGain',
    SurfaceVelocityDuration = 'surface-combo-surfaceVelocityDuration',
    SurfaceVelocityScrubbing = 'surface-combo-surfaceVelocityScrubbing',
    SurfaceVelocityStoreData = 'surface-combo-surfaceVelocityStoreData',
    SurfaceComboSVmaxVelocity = 'surface-combo-surfaceComboSVmaxVelocity',

    // Peak Velocity fields
    VelocityEnable = 'surface-combo-velocityEnable',
    VelocityFrequency = 'surface-combo-velocityFrequency',
    VelocitySensitivity = 'surface-combo-velocitySensitivity',
    VelocityDirection = 'surface-combo-velocityDirection',
    VelocityMaximum = 'surface-combo-velocityMaximum',
    VelocityGain = 'surface-combo-velocityGain',
    VelocityStoreData = 'surface-combo-velocityStoreData',
    VelocityScrubbing = 'surface-combo-velocityScrubbing',
    SurfaceComboPVmaxVelocity = 'surface-combo-surfaceComboPVmaxVelocity',

    // Temperature & Sensor fields
    TemperatureStoreData = 'surface-combo-temperatureStoreData',
    Sensor = 'surface-combo-sensor',

    // Pressure fields
    PressureEnable = 'surface-combo-pressureEnable',
    PressureElectronicOffset = 'surface-combo-pressureElectronicOffset',
    PressureCalibration = 'surface-combo-pressureCalibration',
    PressureStoreData = 'surface-combo-pressureStoreData',
}

export enum SamplerFieldIds {
    SamplingType = 'sampler-sampling-type',
    Trigger = 'sampler-trigger',
    SamplesPerWakeup = 'sampler-samples-per-wakeup',
    Delay = 'sampler-delay',
}